<!--
/**
* @name: YAreaSelect.vue
* @description: 地址选择
* @author: 于海威
* @create: 2020/08/02 09:11:18
* @update: 2020/08/02 09:11:18
*/
-->

<template>
  <div :class="css.select_panel">
    <k-group>
      <k-group-item>
        <k-select v-model="curCountryCode"
          :style="inputStyle"
          @change="onCountryChange"
          clearable
          placeholder="国家">
          <k-option value="1"
            label="中国">中国</k-option>
        </k-select>
      </k-group-item>
      <k-group-item>
        <k-select v-model="curProvinceCode"
          :style="inputStyle"
          @change="onProvinceChange"
          clearable
          :disabled="this.curCountryCode == ''"
          placeholder="省份">
          <k-option v-for="p in arrProvince"
            :label="p.name"
            :value="p.code"
            :key="p.code"
            :selected="p.code == curProvinceCode">{{p.name}}</k-option>
        </k-select>
      </k-group-item>
      <k-group-item>
        <k-select v-model="curCityCode"
          :style="inputStyle"
          @change="onCityChange"
          clearable
          :disabled="curProvinceCode == ''"
          placeholder="城市">
          <k-option v-for="c in arrCity"
            :label="c.name"
            :value="c.code"
            :key="c.code"
            :selected="c.code == curCityCode">{{c.name}}</k-option>
        </k-select>
      </k-group-item>
      <k-group-item>
        <k-select v-model="curCountyCode"
          :style="inputStyle"
          @change="onCountyChange"
          clearable
          :disabled="curCityCode == ''"
          placeholder="区/县">
          <k-option v-for="c in arrCounty"
            :label="c.name"
            :value="c.code"
            :key="c.code"
            :selected="c.code == curCountyCode">{{c.name}}</k-option>
        </k-select>
      </k-group-item>
    </k-group>
    <slot></slot>
    <div class="ml-1">
      <k-button type="primary"
        @click="onAdd">添加</k-button>
    </div>
  </div>
</template>

<script>
import { province, city, county } from '@/components/YArea/areaData';

export default {
  props: {
    width: {
      type: [Number, String],
      default: 400
    }
  },
  computed: {
    inputStyle() {
      const totalInputWidth = this.width;
      const singleInputWidth = Math.floor(parseInt(totalInputWidth) / 4);
      return {
        width: `${singleInputWidth}px`
      };
    },
    arrProvince() {
      return province;
    },
    arrCity() {
      if (this.curProvinceCode) {
        return city[this.curProvinceCode];
      } else {
        return [];
      }
    },
    arrCounty() {
      if (this.curCityCode) {
        return county[this.curCityCode];
      } else {
        return [];
      }
    }
  },
  watch: {
    curCountryCode(v) {
      this.curProvinceCode = '';
      this.curCityCode = '';
      this.curCountyCode = '';
      if (v === undefined) { // 清空国家的时候抛出事件
        this.$emit('clear');
      }
    },
    curProvinceCode(v) {
      this.curCityCode = '';
      this.curCountyCode = '';
    },
    curCityCode(v) {
      this.curCountyCode = '';
    }
  },
  data() {
    return {
      // 当前国家
      curCountryCode: '',
      curCountryName: '',
      curProvinceCode: '',
      curProvinceName: '',
      curCityCode: '',
      curCityName: '',
      curCountyCode: '',
      curCountyName: ''
    };
  },
  methods: {
    onAdd() {
      let para = {};
      if (!(this.curCountryCode || this.curProvinceCode || this.curCityCode || this.curCountyCode)) {
        return this.$root.tip('请选择国家');
      }
      if (this.curCountyCode) { // 选到区县
        para = {
          area: this.curCountyName,
          code: this.curCountyCode,
          fullPath: `${this.curCountryName},${this.curProvinceName},${this.curCityName},${this.curCountyName}`
        };
        return this.$emit('change', para);
      }
      if (this.curCityCode) { // 选到城市
        para = {
          area: this.curCityName,
          code: this.curCityCode,
          fullPath: `${this.curCountryName},${this.curProvinceName},${this.curCityName}`
        };
        return this.$emit('change', para);
      }
      if (this.curProvinceCode) { // 选到省份
        para = {
          area: this.curProvinceName,
          code: this.curProvinceCode,
          fullPath: `${this.curCountryName},${this.curProvinceName}`
        };
        return this.$emit('change', para);
      }
      if (this.curCountryCode) {
        para = {
          area: this.curCountryName,
          code: this.curCountryCode,
          fullPath: `${this.curCountryName}`
        };
        return this.$emit('change', para);
      }
    },
    onCountryChange(country) {
      //   console.log(v);
      this.curCountryName = '中国';
    },
    onProvinceChange(pro) {
      if (pro && pro.v) {
        this.curProvinceName = pro.v;
      }
    },
    onCityChange(cit) {
      if (cit && cit.v) {
        this.curCityName = cit.v;
      }
    },
    onCountyChange(cou) {
      if (cou && cou.v) {
        this.curCountyName = cou.v;
      }
    },
    init() {
      this.curCountryCode = '';
      this.curCountryName = '';
      this.curProvinceCode = '';
      this.curProvinceName = '';
      this.curCityCode = '';
      this.curCityName = '';
      this.curCountyCode = '';
      this.curCountyName = '';
    }
  }
};
</script>

<style lang="postcss" module="css">
.select_panel {
  display: flex;
}
</style>
